import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class repeat_until extends ASTBlock {
    constructor(color) {
        super(color, "repeat_until")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "wiederhole bis %1 %2",
            "args0": [{
                    "type": "input_value",
                    "name": "condition",
                    "check": "Boolean"
                },
                {
                    "type": "input_statement",
                    "name": "statement"
                }
            ],
            "previousStatement": null,
            "inputsInline": false
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}